import { AxiosInstance } from 'axios';
import { Bundle, BundleStatus } from './types';

interface BundleWriteRequest {
  title: string;
  description?: string | null;
  imageUrl?: string | null;
  moduleIds: number[];
  discountPercent: number;
  status: BundleStatus;
  sortOrder: number;
}

export function bundlesApi(client: AxiosInstance) {
  return {
    getList: () =>
      client.post<{ items: Bundle[] }>('/api/v1/admin/bundles/get-list', {}),
    getById: (id: number) =>
      client.post<Bundle>('/api/v1/admin/bundles/get-by-id', { id }),
    create: (data: BundleWriteRequest) =>
      client.post<Bundle>('/api/v1/admin/bundles/create', data),
    update: (data: BundleWriteRequest & { id: number }) =>
      client.post<Bundle>('/api/v1/admin/bundles/update', data),
  };
}
